import React from "react";
import moment from "moment-timezone";
import { Redirect } from "react-router-dom";

import { useQuery } from "hooks";
import { routing } from "routing";

import { ScheduleComponent } from "./ScheduleComponent";

const { Urls } = routing;

const QUERY_KEY_DATE = "date";
const DATE_PATTERN = "YYYY-MM";

export const Schedule = () => {
  const query = useQuery();

  const currentYearMonth = moment().format(DATE_PATTERN);
  const queryParamsDate = query.get(QUERY_KEY_DATE);
  if (!queryParamsDate) {
    return <Redirect to={Urls.CALENDAR_WITH_DATE(currentYearMonth)} />;
  }

  const currentMoment = moment(queryParamsDate, DATE_PATTERN, true);
  if (!currentMoment.isValid()) {
    return <Redirect to={Urls.CALENDAR_WITH_DATE(currentYearMonth)} />;
  }

  return <ScheduleComponent />;
};
